<script setup lang="ts">
import { fr } from '@nuxt/ui/locale'
</script>

<template>
  <NuxtLoadingIndicator color="#c41d73" />
  <NuxtLayout>
    <UApp :locale="fr">
      <NuxtPage />
    </UApp>
  </NuxtLayout>
</template>
